import { render, staticRenderFns } from "./MarkImageLabel.vue?vue&type=template&id=385bd512&scoped=true&"
import script from "./MarkImageLabel.vue?vue&type=script&lang=ts&"
export * from "./MarkImageLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385bd512",
  null
  
)

export default component.exports